import React, { useState, useEffect } from "react";
import axios from "axios";

import ReactQuill from 'react-quill'; // นำเข้า react-quill
import 'react-quill/dist/quill.snow.css'; // นำเข้า styles
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

// function
import { createProduct } from "../../../function/product";
import { listCategory } from "../../../function/category";
import { listCategoryService } from "../../../function/categoryservice";

import FileUpload from "../product/FileUpload";
import { Spin } from 'antd';

const initialstate = {
  title: "",
  description: "",
  categories: [],
  category: "",
  price: "",
  quantity: "",
  images: [],
  points: "",
  employeeDiscount: 0,
};

const CreateProduct = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const [values, setValues] = useState(initialstate);
  const [loading, setLoading] = useState(false);
  const [categoriesService, setCategoriesService] = useState([]);
  const [selectedSource, setSelectedSource] = useState("category");

  const [serviceCenters, setServiceCenters] = useState([]);
  const [selectedServiceCenters, setSelectedServiceCenters] = useState([]);

  const [showAddServiceCenter, setShowAddServiceCenter] = useState(false);
  const [newServiceCenter, setNewServiceCenter] = useState({
    name: "",
    province: "",
    image: "",
    latitude: "",
    longitude: "",
    map: "",
  });



  useEffect(() => {
    loadData(user.token);
    loadDataService(user.token);
  }, []);

  useEffect(() => {
    if (values.category) {
      axios.get(`${process.env.REACT_APP_API}/service-centers?categoryId=${values.category}`)
        .then(res => setServiceCenters(res.data))
        .catch(err => setServiceCenters([]));
    } else {
      setServiceCenters([]);
    }
  }, [values.category]);

  const loadData = (authtoken) => {
    listCategory(authtoken)
      .then((res) => {
        setValues({ ...values, categories: res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const loadDataService = (authtoken) => {
    listCategoryService(authtoken)
      .then((res) => {
        setCategoriesService(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSourceChange = (e) => {
    setSelectedSource(e.target.value);
  };

  const handleEditorChange = (value) => {
    setValues({ ...values, description: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const { title, description, price, quantity } = values;

    if (!title || !description || !price || !quantity) {
      toast.error("กรุณากรอกข้อมูลให้ครบทุกช่อง");
      return;
    }
    createProduct(user.token, { ...values, serviceCenter: selectedServiceCenters, categoryType: selectedSource })
      .then((res) => {
        toast.success("เพิ่มสินค้า " + res.data.title + " สำเร็จ");
        window.location.reload();
      })
      .catch((err) => {
        toast.error("เพิ่มสินค้าไม่สำเร็จ");
      });
  };

  const handleAddServiceCenter = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: newServiceCenter.name,
        province: newServiceCenter.province,
        image: newServiceCenter.image,
        location: {
          latitude: Number(newServiceCenter.latitude),
          longitude: Number(newServiceCenter.longitude),
          map: newServiceCenter.map,
        },
        category: [values.category],
        categoryType: selectedSource
      };
      const resCreate = await axios.post(`${process.env.REACT_APP_API}/service-centers`, payload);
      if (values.category) {
        const res = await axios.get(`${process.env.REACT_APP_API}/service-centers?categoryId=${values.category}`);
        setServiceCenters(res.data);

        // เลือก Service Center ที่เพิ่งเพิ่ม
        if (resCreate.data && resCreate.data._id) {
          setSelectedServiceCenters(prev => [...prev, resCreate.data._id]);
        }
      }
      setShowAddServiceCenter(false);
      setNewServiceCenter({
        name: "",
        province: "",
        image: "",
        latitude: "",
        longitude: "",
        map: "",
      });
      toast.success("เพิ่ม Service Center สำเร็จ");

    } catch (err) {
      toast.error("เพิ่ม Service Center ไม่สำเร็จ");
      console.log(err);
    }
  }

  return (
    <div>
      {loading ? (
        <h1>Loading...<Spin /></h1>
      ) : (
        <h1>Create Product</h1>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group mt-2">
          <label>ชื่อสินค้า</label>
          <input
            className="form-control"
            type="text"
            name="title"
            value={values.title}
            onChange={handleChange}
          />
        </div>

        <div className="form-group mt-2">
          <label>รายละเอียดสินค้า</label>
          <ReactQuill
            value={values.description}
            onChange={handleEditorChange}
            theme="snow"
            placeholder="Enter product description"
          />
        </div>

        <div className="form-group mt-2">
          <label>ราคา</label>
          <input
            className="form-control"
            type="number"
            name="price"
            value={values.price}
            onChange={handleChange}
          />
        </div>

        <div className="form-group mt-2">
          <label>จำนวณ</label>
          <input
            className="form-control"
            type="number"
            name="quantity"
            value={values.quantity}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>คะแนน (Points)</label>
          <input type="number" name="points" className="form-control" value={values.points} onChange={handleChange} />
        </div>
        <div className="form-group mt-2">
          <label>ส่วนลดพนักงาน (%)</label>
          <input
            type="number"
            name="employeeDiscount"
            className="form-control"
            value={values.employeeDiscount || ""}
            onChange={handleChange}
            placeholder="กรอกเปอร์เซ็นต์ส่วนลด เช่น 10"
            min="0"
            max="100"
          />
          <small className="text-muted">กรอกเปอร์เซ็นต์ส่วนลดสำหรับพนักงาน (0-100%)</small>
        </div>

        <div className="form-group mt-2">
          <label>Source</label>
          <select
            className="form-control"
            value={selectedSource}
            onChange={handleSourceChange}
          >
            <option value="category">Category</option>
            <option value="categoryService">Category Service</option>
          </select>
        </div>

        <div className="form-group mt-2">
          <label>Category</label>
          <select
            className="form-control"
            name="category"
            onChange={handleChange}
            required
          >
            <option>Pless select</option>
            {selectedSource === "category" &&
              values.categories.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            {selectedSource === "categoryService" &&
              categoriesService.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>
        <div className="form-group mt-2">
          <label>Service Center</label>
          <select
            className="form-control"
            multiple
            value={selectedServiceCenters}
            onChange={e => {
              const options = Array.from(e.target.selectedOptions, option => option.value);
              setSelectedServiceCenters(options);
            }}
            disabled={!values.category} // ถ้ายังไม่เลือก category ให้ disable
          >
            {serviceCenters.map(center => (
              <option key={center._id} value={center._id}>
                {center.name} ({center.province})
              </option>
            ))}
          </select>
          <small className="text-muted">เลือก Service Center ได้หลายรายการ (กด Ctrl หรือ Cmd)</small>
          <br />
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={() => setShowAddServiceCenter(!showAddServiceCenter)}
          >
            + เพิ่ม Service Center ใหม่
          </button>
          {showAddServiceCenter && (
            <div className="mt-2 border rounded p-2 bg-light">
              <input
                className="form-control mb-1"
                placeholder="ชื่อ Service Center"
                value={newServiceCenter.name}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, name: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="จังหวัด"
                value={newServiceCenter.province}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, province: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="URL รูปภาพ"
                value={newServiceCenter.image}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, image: e.target.value })}
                required
              />
              <input
                className="form-control mb-1"
                placeholder="Latitude"
                value={newServiceCenter.latitude}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, latitude: e.target.value })}
                required
                type="number"
              />
              <input
                className="form-control mb-1"
                placeholder="Longitude"
                value={newServiceCenter.longitude}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, longitude: e.target.value })}
                required
                type="number"
              />
              <input
                className="form-control mb-1"
                placeholder="Google Map URL"
                value={newServiceCenter.map}
                onChange={e => setNewServiceCenter({ ...newServiceCenter, map: e.target.value })}
              />
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={handleAddServiceCenter}
              >
                บันทึก
              </button>
              <button
                type="button"
                className="btn btn-sm btn-secondary ml-2"
                onClick={() => setShowAddServiceCenter(false)}
              >
                ยกเลิก
              </button>

            </div>
          )}
        </div>
        <div className="form-group mt-5">
          <label>อัพโหลดรูปสินค้า</label>
          <FileUpload
            values={values}
            setValues={setValues}
            setLoading={setLoading}
          />
        </div>
        <div className="form-group mt-3">
          <button className="btn btn-primary">บันทึก</button>
          {/* <button
            className="btn btn-primary"
            type="submit"
            disabled={loading}
          >
            {loading ? "กำลังบันทึก..." : "บันทึกสินค้า"}
          </button> */}
        </div>
      </form>
    </div>
  );
};

export default CreateProduct;